import RecentPost from './RecentPost'
export default RecentPost